import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";
import { purchaseOrders } from "./purchase-orders";
import { items, accounts, taxTemplates } from "../../accounting/schemas/public";

// ============================================================================
// purchase_order_items — รายการในใบสั่งซื้อ
// ============================================================================
export const purchaseOrderItems = sqliteTable("purchase_order_items", {
  id: text("id").primaryKey(), // ULID
  purchaseOrderId: text("purchase_order_id").notNull().references(() => purchaseOrders.id), // FK -> purchase_orders
  itemId: text("item_id").references(() => items.id), // FK -> items (nullable for manual entry)
  description: text("description"),
  qty: real("qty").notNull().default(1),
  rate: real("rate").notNull().default(0),
  amount: real("amount").notNull().default(0),
  receivedQty: real("received_qty").notNull().default(0),
  receivedAmount: real("received_amount").notNull().default(0),
  billedQty: real("billed_qty").notNull().default(0),
  billedAmount: real("billed_amount").notNull().default(0),
  accountId: text("account_id").references(() => accounts.id), // FK -> accounts (override item default)
  taxTemplateId: text("tax_template_id").references(() => taxTemplates.id), // FK -> tax_templates
  taxAmount: real("tax_amount").notNull().default(0),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
}, (table) => ({
  purchaseOrderIdx: index("poi_purchase_order_idx").on(table.purchaseOrderId),
}));

// Type exports
export type PurchaseOrderItem = typeof purchaseOrderItems.$inferSelect;
export type NewPurchaseOrderItem = typeof purchaseOrderItems.$inferInsert;
